export const MENU_BAR_WIDTH_PIXELS = 56;
